import Auth from '../auth/Auth';
import Waive from '../models/Waive';
import { WebClient } from './WebClient'

class ApiWaive extends WebClient {
    async getWaives(): Promise<Waive[]> {
        const url = "/waive";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateWaive(data: Waive): Promise<Waive> {
        return this.put("/waive", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }
}

export default new ApiWaive();
